export interface PopoutPosition {
  x: number;
  y: number;
}

interface Size {
  width: number;
  height: number;
}

export const DEFAULT_POPOUT_VIEWPORT_MARGIN = 12;

const clamp = (value: number, min: number, max: number) =>
  Math.min(Math.max(value, min), Math.max(min, max));

/**
 * Keeps a horizontally centered, fixed-position popout inside the viewport.
 *
 * Calendar popouts render in document.body so parent overflow cannot clip them.
 * Their click coordinates are only an initial anchor; after render, this helper
 * uses the measured popout size to leave a small margin around every edge.
 */
export const getViewportSafePopoutPosition = (
  anchor: PopoutPosition,
  popoutSize: Size,
  viewportSize: Size,
  margin = DEFAULT_POPOUT_VIEWPORT_MARGIN
): PopoutPosition => ({
  x: clamp(
    anchor.x,
    popoutSize.width / 2 + margin,
    viewportSize.width - popoutSize.width / 2 - margin
  ),
  y: clamp(anchor.y, margin, viewportSize.height - popoutSize.height - margin),
});
